var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondPwc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 0.938721,
    y: 13,
    width: 18,
    height: 18,
    transform: "rotate(-45 0.938721 13)",
    fill: "#3769FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondPwc);
export default __webpack_public_path__ + "static/media/diamondPWC.8c569835a645e87e17d53b739d604d2f.svg";
export { ForwardRef as ReactComponent };